// checks if the user has selected a link and returns that link or false
export const checkIfSelectedLink = (anchorNode?: HTMLElement | null) => {
  anchorNode = anchorNode || window.getSelection()?.anchorNode?.parentElement;

  if (anchorNode) {
    const startElement = anchorNode;
    if (startElement) {
      let currentElement = startElement;
      do {
        const isLink = currentElement.nodeName == 'A';
        if (isLink) {
          return currentElement;
        } else if (currentElement.parentElement) currentElement = currentElement.parentElement;
        else break;
      } while (currentElement && !currentElement.classList.contains('node-text-root'));
    }
  }

  return false;
};
